import conf from "../config";
import RECORD from "./record.ts";
const base = {
    xjbName: () => {
        return sessionStorage.getItem("xjbName");
    },
    xjbSName: () => {
        return sessionStorage.getItem("xjbName");
    },
    xjbFundName: () => {
        let obj = JSON.parse(sessionStorage.getItem("xjbFundInfo"));
        return (obj && obj.fundname) || "";
    },
    xjbFundCode: () => {
        let obj = JSON.parse(sessionStorage.getItem("xjbFundInfo"));
        return (obj && obj.fundcode) || "";
    }
};

const constant = {
    CN: "CN", // 中国 代码
    HK: "HK",
    TW: "TW",
    MO: "MO",
    CN_ITEM: { CN: "中国" },
    CN_MOBILE: "86", // 手机国家码
    AREA_BEIJING: "010", // 默认地区码 北京
    CN_MOBILE_ITEM: { val: "86", txt: "中国+86" },
    COUNTRY_CN: "中国", // 默认国家
    DICT: {
        COUNTRY: "120109",
        COUNTRYCODE_MOBILE: "150136",
        AREACODE_TELPHONE: "150137",
        SPECIALPERSONFLAG: "120200",
        PROVINCE: "190021",
        CITY: "190022",
        COUNTY: "190023",
        CAREERTYPE: "150141"
    },
    VAILDDATE_FOREVER: "99991231",
    IMG_BIZTYPE: {
        // 图形验证码业务码
        REGISTER: "0", // 注册
        RESETPWD: "1", // 重置密码
        CHANGEPWD: "2", // 修改密码
        CHANGEMOBILE: "3", // 修改手机
        OTHER: "4", // 普通
        RESETLOGINPWD: "5", // 重置登录密码
        SMSLOGIN: "6", // 短信登录
        SMSVALID: "7", // 双因素验证
        BIND_PHONE: "9", // 绑定手机号
        UNSUBSCRIBE: "8", // 注销账户
        REGISTERPWD: "10", // 纯注册户登录密码
        CONSIGNMENTPWD: "11", // 纯代销户登录密码
        TWOFACTORAUTH: "12" // 双因素验证
    },
    COMPANY: "", // 公司名称
    commonQuestion: {
        commonQuestion1: [
            {
                title: "1.使用农行卡开户、重置密码或换卡，跳转至银行页面后为何显示找不到请求记录？",
                answer: "该问题是由于银行方面的通讯原因造成，请您返回至上一步重新提交一次。",
                showFlag: false
            }
        ],
        commonQuestion2: [
            {
                title: "1.为什么要签约？ ",
                answer: "基金定投业务需要银行托收扣款，故需要进行相关银行卡的托收签约。",
                showFlag: false
            },
            {
                title: "2.如果解约会有什么影响？",
                answer: "当您解约后，相关银行卡的定投计划将无法顺利托收扣款。",
                showFlag: false
            }
        ],
        commonQuestion3: [
            {
                title: "1.什么是基金认购？认购后基金封闭期多长？",
                answer: "基金认购是指在开放式基金募集期间、基金尚未成立时购买基金份额的过程。基金封闭期自基金成立日起最长不超过3个月（即最长3个月），如果提前打开申购或赎回，公司会提前2日在公司网站或相关媒体上公告。",
                showFlag: false
            },
            {
                title: "2.申购和认购有什么区别？",
                answer: "基金首次募集期购买基金的行为称为认购；在基金成立后购买基金的行为称为申购；一般情况下，认购期购买基金的费率相对来说要比申购期购买优惠。认购期购买的基金一般要经过封闭期才能赎回，申购的基金要在申购成功后的第二个工作日才能进行赎回。",
                showFlag: false
            },
            {
                title: "3.认购可以撤单吗？",
                answer: "认购申请一经受理，不得撤销。投资者在募集期内可多次认购基金份额，其认购金额按照单笔认购金额对应的费率为基准进行计算。",
                showFlag: false
            },
            {
                title: "4.认购持有期是从什么时候开始算起的？认购冻结金额有利息吗？",
                answer: "认购的基金持有期限从基金成立日开始算（例如：10月1日认购的新基金，假设基金于11月1日成立，则到12月1日，持有时间为31天）。认购期冻结资金会按原认购金额（不扣除认购费）计算利息，会折算成基金份额计入客户基金账户。",
                showFlag: false
            },
            {
                title: "5.我认购的基金为什么查不到份额？",
                answer: "您认购的基金目前正处于验资期，验资结束后我司会公告基金成立，届时即可查询到份额确认情况。",
                showFlag: false
            },
            {
                title: `6.当投资者办理“认购”业务时，选择资金来源为 “${base.xjbName()}”，办理的是什么业务？`,
                answer: `办理的是${base.xjbName()}下的${base.xjbFundName()}（${base.xjbFundCode()}）向所认购基金的赎回转认购业务。`,
                showFlag: false
            },
            {
                title: "7.什么是七日年化收益率和日每万份收益？",
                answer: "日每万份收益是指每万份基金单位当日净收益。日每万份基金净收益＝当日基金净收益/当日基金份额总额×10000。七日年化收益率是指货币基金最近连续7个自然日每万份基金份额净收益折合成的年收益率，代表过去的收益情况，仅供参考。招财宝基金收益分配方式是每日分配、按日支付。收益是T+2个工作日起可以赎回。当您在今日赎回时，昨日的收益需要下个工作日才可以赎回。",
                showFlag: false
            },
            {
                title: "8.旗下的基金产品在法定节假日期间是否暂停申购？",
                answer: "有些基金在法定节假日期间确实会暂停申购，具体情况请您提前关注我们的公司公告，提前做好交易安排，以免造成不便。",
                showFlag: false
            }
        ],
        commonQuestion4: [
            {
                title: "1.基金转换后什么时候开始确认份额？",
                answer: "于当日下午3点前提交的基金转换，客户可以于T+1日确认交易有效性。于当日下午3点以后提交的基金转换指令，客户须于T+2日确认交易有效性。",
                showFlag: false
            },
            {
                title: "2.基金转换成交净值如何计算？",
                answer: "基金转换采取未知价法，即以申请受理当日各转出、转入基金的基金份额净值为基础进行计算（货币市场基金的基金份额净值为固定价1元）。",
                showFlag: false
            }
        ],
        commonQuestion5: [
            {
                title: "1.选择现金分红和红利再投有何区别？",
                answer: "目前基金分红有现金分红和红利转投两种方式。现金分红让投资者直接获得现金回报，而红利转投则将所得的现金红利转化为基金份额。比较来说，现金分红将使投资者得到现金红利，满足落袋为安的心理；对于基金的长期投资者而言，选择红利转投则可使所得现金红利无成本的折算为基金份额，起到“复利”的投资效果。",
                showFlag: false
            },
            {
                title: "2.如果我从来没有修改过分红方式，会如何分红？",
                answer: "如果没有选择具体分红方式，基金默认的分红方式以基金合同为准。货币基金只有红利再投的分红方式。",
                showFlag: false
            },
            {
                title: "3.修改分红方式后多久可以确认结果？",
                answer: "修改分红方式申请结果以基金公司注册登记部门的确认结果为准。请您于T+2日通过历史交易查询查询确认结果。",
                showFlag: false
            },
            {
                title: "4.权益登记日可以修改分红方式吗？",
                answer: "权益登记日可以提交修改分红方式的申请，但是将于下次分红生效。",
                showFlag: false
            },
            {
                title: "5.为什么我修改完分红方式，当前分红方式还是没修过的？",
                answer: "分红方式修改需要T+1确认，待确认后，当前分红方式将会自动变更为修改后的。",
                showFlag: false
            }
        ],
        commonQuestion6: [
            {
                title: "1.什么是外扣法？",
                answer: "“外扣法”是证监会要求使用的计算基金申购费用和申购份额的计算方法。外扣法意味着投资者用同样的钱，购买的基金份额将会比内扣法方式购买的多。<br>外扣法是针对实际购买金额，即净投资额的。具体计算公式如下：<br>净申购金额＝申购金额/（1＋申购费率）<br>申购费用＝申购金额－净申购金额<br>申购份额＝净申购金额/申购当日基金份额净值。",
                showFlag: false
            }
        ],
        commonQuestion7: [
            {
                title: "1.基金赎回按什么净值成交？",
                answer: "基金赎回采用“份额赎回、未知价法”，即投资者的赎回以份额方式申请，以申请当日的基金份额净值为基准计算。扣除相应的赎回费后，确认实际赎回金额。",
                showFlag: false
            },
            {
                title: "2.我在银行赎回基金，要多久到账？",
                answer: "货币型基金、理财产品T+1个工作日划款，标普500基金、纳斯达克基金T+7个工作日划款，其他基金T+2个工作日划款。我们将直接划款到银行，然后由银行划款到您账户。到帐速度看银行内部的划款速度。",
                showFlag: false
            },
            {
                title: "3.多次申购的基金，赎回时是赎回哪部分份额？",
                answer: "赎回按“先进先出”原则，也就是先购买的份额先赎回。",
                showFlag: false
            },
            {
                title: "4.赎回款一直没有到账，是什么原因？",
                answer: "货币型基金、理财产品T+1个工作日划款，标普500基金、纳斯达克基金T+7个工作日划款，其他基金T+2个工作日划款。如超过上述期限三个工作日，赎回款仍未到账，请持有网上直销账号的客户先确认自己的赎回交易是否被确认，并核对您查询的银行卡是否是您购买基金时使用的银行卡。之后再拨打我们的客服电话（免长途话费）：400 888 5558进行进一步的咨询。",
                showFlag: false
            },
            {
                title: "5.我以前是在代销机构买的基金，能不能在网上交易办理赎回？",
                answer: "不能直接办理。您需要先办理跨系统转托管手续，将代销机构的基金份额转托管至基金网上交易，方可在网上交易办理赎回。<br>操作流程如下：<br>第一步：开通基金网上交易<br>第二步：前往代销机构办理转托管转出手续；<br>第三步：转出之后2个工作日登录网上交易系统查询份额。<br>注：自建TA：代销机构在申报转托管时需填写销售商代码209，网点号根据网上交易使用的银行卡填写不同的代码，参照如下：209柜台客户，3000其他银联通客户，3100兴业银联通客户，3200浦发银联通客户，3300中信银联通客户，3400富滇银联通客户，3500长沙银联通客户，3600南京银联通客户，3700金华银联通客户，3800上农商银联通客户，4000工行网银客户，5000好易联客户，A000农行网银客户，B000建行网银客户，G000招行网银客户，J000民生网银客户，6000天天盈客户。如果代销渠道的系统不能填写网点号，则不能转托管到网上交易。<br>中登TA：销售商代码填680209，网点号填680209或不填，默认转到网上交易开户的银行卡上。",
                showFlag: false
            },
            {
                title: `6.赎回非货币基金时选择“赎回到${base.xjbName()}”，基金份额什么时候可用？`,
                answer: `赎回非货币基金时选择资金赎回到“${base.xjbName()}”，等同于把该基金转换或者赎回转申购为货币基金，货币基金份额需要在转换或者赎回转申购交易确认成功后才可使用。`,
                showFlag: false
            }
        ],
        commonQuestion8: [
            {
                title: "1.请问哪些基金开通了转换？",
                answer: "您可以在我司官网进入您需要查询的基金的专栏，于产品公告中查看相关公告。",
                showFlag: false
            }
        ],
        commonQuestion9: [
            {
                title: "1.什么是跨系统转托管？",
                answer: "跨系统转托管业务是指持有人将持有的基金份额在注册登记系统和证券登记结算系统之间进行转登记的行为。例如：客户在场外持有LOF基金，现在想通过场内进行交易卖出，即可办理跨系统转托管业务，将场外的份额转登记到场内系统，确认成功后可办理上市交易。",
                showFlag: false
            },
            {
                title: "2.如何办理跨系统转托管？",
                answer: "（1）第一步：开立证券账户，在准备转入的证券公司开立股东账户，在证券公司办理建立场内外基金账户对应关系业务，并与证券公司营业部的交易所确认席位号。<br>（2）第二步：提交申请，在基金官网提交办理申请，需注意，转托管份额必须为整数份。<br>（3）第三步：查询交易：提出申请后2个交易日即可通过证券公司查询或卖出。",
                showFlag: false
            }
        ],
        commonQuestion10: [
            {
                title: `1.什么是${base.xjbName()}？`,
                answer:
                    "<div>\n" +
                    `\t${base.xjbName()}是专为网上交易客户设计的现金管理和投资工具，赎回到“${base.xjbName()}”，${base.xjbFundName()}(${base.xjbFundCode()})，可享受货币基金收益。<br></div>`,
                showFlag: false
            },
            {
                title: "2.我在银行赎回基金，要多久到账？",
                answer: "货币型基金、理财产品T+1个工作日划款，标普500基金、纳斯达克基金T+7个工作日划款，其他基金T+2个工作日划款。我们将直接划款到银行，然后由银行划款到您账户。到帐速度看银行内部的划款速度。",
                showFlag: false
            },
            {
                title: "3.赎回到账金额是如何计算的？",
                answer: "<div>赎回费用＝赎回当日基金净值×赎回份额×赎回费率<br>赎回金额=赎回当日基金单位资产净值×赎回份额－赎回费用<div/> ",
                showFlag: false
            },
            {
                title: "4.赎回费率是多少？是否有优惠？赎回费率是多少？是否有优惠？",
                answer: "<div>一般基金赎回费率按持有年限收取。请您点选具体的基金，在相应基金的页面中点击该基金的“费率”标签，在“赎回费率”部分查看该基金的赎回费率。<br>货币基金没有赎回费。<div/> ",
                showFlag: false
            },
            {
                title: "5.开放式基金的赎回费如何计算？",
                answer:
                    "<div>开放式基金的赎回费用及金额计算方法如下：<br>赎回费用=赎回份额×T日基金单位净值×赎回费率\n" +
                    "<br>赎回金额=赎回份额×T日基金单位净值-赎回费用<br>假如投资者赎回1000份基金单位，假设赎回费率为0.5％，当日的基金单位资产净值为1元，其得到的赎回金额为： <br>赎回费用=1000×1×0.5％=5元\n" +
                    "<br>赎回金额=1000×1-5=995元<div/>",
                showFlag: false
            },
            {
                title: "6.什么是巨额赎回？",
                answer:
                    "<div>单个开放日中，如果一只基金的净赎回申请超过该基金上一日基金总份额的10％时，即认为该基金发生了巨额赎回。\n" +
                    "如果遇到巨额赎回，则提交的赎回份额会按一定比例赎回，如果选择“放弃超额部分”则放弃赎回剩余部分，如果选择“继续赎回”则剩余部分会作为下一工作日的赎回申请继续赎回。<div/>",
                showFlag: false
            }
        ],
        commonQuestion11: [
            {
                title: "1.详细了解智能定投？",
                answer: "智能定投是传统“定期定额投资”方式的改良，又称“定期不定额投资”，智能定投可根据证券市场的走势以不固定金额进行投资，实现对投资时点的自动判断和对投资金额的灵活控制，力争使定投收益最大化。<br>具体地说，智能定投是指在每月固定的日期（T日），根据T-1日某证券市场指数与该指数均线的比较情况，在T日自动增加或减少基金定投金额。在证券市场指数低于该指数均线时，增加每月扣款金额；高于该指数均线时，减少每月扣款金额。即在基金净值较低时，增加投资金额，获得更多份额；在基金净值较高时，减少投资金额，从而进一步降低申购成本，使得成本平摊效果更好。",
                showFlag: false
            },
            {
                title: "2.如果约定扣款日正好遇到节假日，还会扣款吗？",
                answer: "扣款日遇到非工作日的，将自动顺延到下一工作日扣款。",
                showFlag: false
            },
            {
                title: "3.已设置的定投计划，连续几次扣款不成功会怎么样？",
                answer: "连续六期扣款失败，协议会自动暂停。",
                showFlag: false
            },
            {
                title: "4.已办理的定投业务，是否可以增加扣款金额？",
                answer: "可以，请您登录“网上交易”，点击我的定投栏目，并通过修改操作进行修改定投协议。可以修改您的扣款日期，扣款频率及扣款金额。",
                showFlag: false
            },
            {
                title: "5.定投协议取消后基金份额还在吗？",
                answer: "终止定投协议不等于基金赎回。取消定投协议后将不会再进行定投扣款，但已经定投申购的基金份额仍保留在基金账户中，您可以根据需要继续持有或选择合适时机赎回、转换。",
                showFlag: false
            }
        ],
        commonQuestion13: [
            {
                title: "1.为什么我绑定的银行卡在新增定投计划时不能使用？",
                answer: "非常抱歉， 部分银行卡不支持定投功能，故不会在扣款账号中展示。",
                showFlag: false
            }
        ],
        commonQuestion14: [
            {
                title: "1.农行个人网银控件安装失败怎么办？",
                answer: "1.兼容性设置：使用IE浏览器，选择【工具→兼容性视图设置】，将访问的农行网址加入到兼容性视图网站。<br>2.将安全控件下载到本地计算机后，关闭所有浏览器，使用已下载的安装文件（大小在1M以上）进行安装。<br>3.平板、手机端开户建议使用农行快捷方式。",
                showFlag: false
            }
        ],
        commonQuestion15: [
            {
                title: "1.申购费率是多少？是否有优惠？",
                answer: "各只基金申购费率应分别至该基金的专题页面—基金费率—申购费板块查看。各销售机构根据公告有不同程度费率优惠。具体优惠费率请您咨询相关代销机构或者拨打基金统一客服热线400-888-5558。<br>货币基金没有申购费。",
                showFlag: false
            },
            {
                title: "2.开放式基金的申购费如何计算？",
                answer: "开放式基金的申购费用及份额计算方法如下：<br>净申购金额 = 申购金额/（1 + 申购费率）<br>申购费用 = 申购金额 -净申购金额<br>申购份额 = 净申购金额/ T日基金份额净值<br>假如投资者投资15000元申购某开放式基金，假设申购费率为1.5%，当日的基金单位净值为1.52元/份，其得到的份额为：<br>净申购金额=15000/(1+1.5%)=14778.33元<br>申购费用=15000-14778.33=221.67元<br>申购份额=14778.33/1.52=9722.58份",
                showFlag: false
            },
            {
                title: `3.当投资者办理“申购”业务时，选择资金来源为 “${base.xjbName()}”，办理的是什么业务？`,
                answer: `办理的是${base.xjbName()}下的${base.xjbFundName()}（${base.xjbFundCode()}）向所申购基金的转换、赎回转申购业务（未开通转换业务时）。`,
                showFlag: false
            },
            {
                title: "4.最新净值就是交易价格吗？",
                answer: "最新净值展示的实际是上一个交易日的净值。基金交易遵循未知价原则，您在交易日15:00前提交的交易申请的价格将以当日基金净值为准。您在交易日15:00后或节假日提交的交易申请的价格将以下一交易日的基金净值为准。",
                showFlag: false
            }
        ],
        commonQuestion16: [
            {
                title: "1.在公司网站上是否有后端定投业务，定投起点是多少？",
                answer: "我司网站已开通后端收费模式的基金，可以在网上进行后端定投，起点一般为1元，具体请查看产品公告。",
                showFlag: false
            },
            {
                title: `2.当投资者办理“定期定投”或“智能定投”时，选择资金来源为“${base.xjbName()}”，办理的是什么业务？`,
                answer: `办理的是${base.xjbName()}下的${base.xjbFundName()}（${base.xjbFundCode()}）向定投目标基金的定期转换业务`,
                showFlag: false
            }
        ],
        commonQuestion17: [
            {
                title: "1.选择银行卡提交后，页面显示的是“请您在打开的网上银行页面上验证银行卡”，但是我并没有看到网上银行页面啊？",
                answer: "您的浏览器可能拦截了弹出银行页面，需要修改浏览器的设置。我们建议您使用IE8以上浏览器，设置方法是：工具—internet选项—隐私—把“弹出窗口阻止程序”选项的勾去掉。然后再重新进行开户。如果还是弹不出银行网页，建议您换台电脑试试。",
                showFlag: false
            },
            {
                title: "2.页面显示“正在跳转”，但是一直没有反应？",
                answer: "这个问题可能是银行页面访问通讯问题，建议返回到第一步的选择银行卡验证，重新提交一次。",
                showFlag: false
            },
            {
                title: "3.验证时提示“银行卡验证信息及身份信息或手机号输入不正确”？",
                answer: "这说明您提交的开户信息里，您的手机号码、姓名、身份证号码等信息，与您当时银行卡开卡时预留的相关不一致。还请您核对相关信息重新提交开户。",
                showFlag: false
            },
            {
                title: "4.我的姓名和身份证号码明明是正确的，为什么还是说身份信息不符？",
                answer: "这个问题可能是您银行开卡是身份证有15/18位的问题，建议您在提交的信息中把身份号码进行升降位后再重试。如果仍无法提交，请联系我们的客服人员协助解决。",
                showFlag: false
            },
            {
                title: "5.用招行卡开户提示协议已存在，怎么办？",
                answer: "这一般是首次开户未完成而导致的。如遇这种情况，请与我们的客服联系协助解决。",
                showFlag: false
            },
            {
                title: "6.使用农行卡开户、重置密码或换卡，跳转至银行页面后为何显示找不到请求记录？",
                answer: "该问题是由于银行方面的通讯原因造成，请您返回至上一步重新提交一次。",
                showFlag: false
            }
        ]
    },
    RECORD: RECORD,
    getXJBParam: (key) => {
        switch (key) {
            case "name": {
                return base.xjbName();
            }
            case "sname": {
                return base.xjbSName();
            }
            case "fundname": {
                return base.xjbFundName();
            }
            case "fundcode": {
                return base.xjbFundCode();
            }
            default: {
                return key;
            }
        }
    },
    zxTradingNoticeLink: "https://www.cfund108.com/main/a/20140718/10000582.shtml",
    warmReminderDisplay: false, // 控制温馨提示显示隐藏
    serviceBookingDisplay: false, // 服务订阅开关
    pwdmodifySearch: false, // 密码修改记录
    institutionaLogin: false, // 机构登录跳转入口开关
    monthlyStatementDisplay: true, // 对账单查询入口开关
    tracesLogDisplay: false, // 下载资产证明入口开关
    transDisplay: false // 投资者转换按钮
};
export default constant;
